<form id="cadastre-form" class="px-4" [formGroup]="cadastreForm">
  <div class="row">
    <div class="col-12">
      <div class="mb-3">
        <p-input
          [formControl]="this.cadastreForm.controls.cityLabel"
          id="cityLabel"
          name="cityLabel"
          label="Commune"
          [tabindex]="1"
          [disabled]="true"
        ></p-input>
      </div>
    </div>
  </div>

  <div class="border border-1 rounded p-4 mt-4">
    <div class="col-12 mb-3">
      <p class="text-muted small">
        <sup class="text-danger">*</sup> Les champs marqués d'un astérisque sont
        obligatoires
      </p>
    </div>

    <div class="d-flex align-items-end gap-3">
      <div class="col-3">
        <p-input
          [formControl]="this.cadastreForm.controls.plotPrefixe"
          id="plotPrefixe"
          name="plotPrefixe"
          label="Préfixe"
          placeholder="000"
          [tabindex]="2"
          [maxLength]="3"
          (input)="plotPrefixeChanged($event)"
        ></p-input>
      </div>

      <div class="col-3">
        <p-input
          [formControl]="this.cadastreForm.controls.plotSection"
          id="plotSection"
          name="plotSection"
          label="Section"
          placeholder="00"
          [tabindex]="3"
          [maxLength]="2"
          (input)="plotSectionChanged($event)"
        ></p-input>
      </div>

      <div class="col-3">
        <p-input
          [formControl]="this.cadastreForm.controls.plotNumber"
          id="plotNumber"
          name="plotNumber"
          label="Numéro"
          placeholder="0000"
          [tabindex]="4"
          [maxLength]="4"
          (input)="plotNumberChanged($event)"
        ></p-input>
      </div>

      <div class="col-3">
        <p-button
          label="Vérifier"
          level="primary"
          [tabindex]="5"
          [loading]="isLoading"
          [disabled]="isLoading || !isReadyforCheck"
          (click)="onCheckCadastre()"
        ></p-button>
      </div>
    </div>

    <div *ngIf="plot && isPlotFound && hasChecked" class="mt-4">
      <div class="row">
        <div class="alert alert-success" role="alert">
          <strong>Parcelle validée</strong>
          <p>
            Nous avons trouvé la parcelle {{ plotRef }} dans la base cadastrale.
          </p>
          <ul>
            <li *ngIf="plot.totalArea">
              Surface totale: {{ plot.totalArea }} m²
            </li>
            <li *ngIf="plot.buildings && plot.buildings.length > 0">
              Bâtiments présents: {{ plot.buildings.length }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div *ngIf="!isPlotFound && hasChecked" class="mt-4">
      <div class="alert alert-danger" role="alert">
        <strong>Parcelle non trouvée</strong>
        <p>
          Nous n'avons pas trouvé la parcelle {{ plotRef }} dans la base
          cadastrale.
        </p>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <p-textarea
        [formControl]="this.cadastreForm.controls.comment"
        id="comment"
        name="comment"
        label="Commentaire"
        [maxLength]="2500"
        [showCounter]="true"
        (input)="commentChanged($event)"
      ></p-textarea>
    </div>
  </div>
</form>
